import { render, staticRenderFns } from "./_ibcBot.vue?vue&type=template&id=548ce109&lang=pug&"
import script from "./_ibcBot.vue?vue&type=script&lang=js&"
export * from "./_ibcBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports